import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'batch_number', label: 'Batch' },
  { key: 'transaction_type_label', label: 'Transaction Type' },
  { key: 'source_description', label: 'Source' },
  { key: 'amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'rejection_reason', label: 'Reason' },
  { key: 'rejected_at', label: 'Rejected At' },
  { key: 'days_outstanding', label: 'Days Outstanding', align: 'right' },
];

export function ExceptionsReport() {
  return (
    <ReportView
      title="GL Exceptions — Rejected Postings"
      description="Batch lines FAMS rejected, still outstanding (not yet requeued), bucketed by age."
      endpoint="/reports/gl/exceptions"
      columns={COLUMNS}
      defaultSort="days_outstanding"
    />
  );
}
